<template>
  <div>
    <div v-if="locationId == 0">
      <locations @set-location="setLocationData" :isValid="isStepValid"></locations>
    </div>
    <div v-else>
          <b-row>
      <b-col cols="11">
        <h4>You are adding a survey for: {{ location }}</h4>
      </b-col>
      <b-col class="text-right">
        <b-btn :to="{ name: 'surveyMenu' }" class="btn btn-light">X</b-btn>
      </b-col>
    </b-row>
      <volunteer-pin
        v-show="surveyStep == 0"
        :location="location"
        :locationCode="locationCode"
        :locationId="locationId"
        @move-next="setName"
        :isValid="isStepValid"
        :surveyData="surveyData"
      ></volunteer-pin>
      <breadcrumb
        v-show="surveyStep > 0"
        :surveyStep="surveyStep"
        :maxStepCompleted="maxStepCompleted"
        @move-to-step="moveToStep"
      ></breadcrumb>

      <component
        :is="currentStep"
        :surveyData="surveyData"
        :isValid="isValid"
        @move-next="moveNext"
        @move-previous="movePrevious"
      ></component>
    </div>

    <!-- <survey-nav :step="surveyStep" @move-next="moveNext" @move-previous="movePrevious"></survey-nav> -->
  
    <nav class="navbar fixed-bottom survey-footer">
      Debug Info: Location {{ location }}&nbsp;-&nbsp;volunteer: {{ surveyData.VolunteerName }}&nbsp;-&nbsp;On step {{ surveyStep }}&nbsp;-&nbsp;Max step completed was {{ maxStepCompleted }}
    </nav>

  </div>
</template>

<script>
import Locations from "./Location";
import VolunteerPin from "./VolunteerPin";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import Step7 from "./Step7";
import Step8 from "./Step8";
import Breadcrumb from "./Breadcrumb";
import surveyNav from "@/components/SurveyNav";

export default {
  name: "survey",
  data: () => ({
    isValid: false,
    volunteerPinCode: "",
    surveyStep: 0,
    maxStepCompleted: 0,
    location: "Survey Location",
    locationCode: "ABc",
    locationId: 0,
    currentStep: "",
    surveyData: {
        Id: 0,
        IsComplete: false,
        LocationId: 0,
        VolunteerId: 0,
        VolunteerName: "",
        DiagnosedDiabetes: null, //boolean
        Age: null, //number
        Gender: null, //boolean
        DiagnosedGestationalDiabetes: null, //boolean
        RelativeWithDiabetes: null, //boolean
        DiagnosedHighBP: null, //boolean
        PhysicallyActive: null, //boolean
        Weight: null,
        HeightFeet: null,
        HeightInches: null,
        TotalRiskScore: 0,
        BMI: 0,
        Race: "",
        Ethnicity: null, //passed as 1 or 2
        CountryOfBirth: null,
        ZipCode: "",
        HaveHealthCoverage: null, //boolean
        HealthInsurancePlanName: "",
        ContactForHealthCoverage: null, //tinyint
        ContactForDiabetesPrevention: null, //boolean
        FirstAndLastName: "",
        TelephoneNumber: "",
        EmailAddress: "",
        HavePrimaryDoctor: null, //boolean
        FollowUpResults: null, //boolean
       GlucoseReading: null,
        A1CNumber: null,
        LipidsCholHdl: null,
        LipidsLdlC: null,
        LipidsChol: null,
        LipidsHdlC: null,
        LipidsTrig: null
    }
  }),
  components: {
    Locations,
    VolunteerPin,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6,
    Step7,
    Step8,
    Breadcrumb,
    surveyNav
  },
  methods: {
    setLocationData(event) {
      this.location = event.locName;
      this.locationId = event.locId;
      this.surveyData.locationId = this.locationId;
    },
    setName(event) {
      this.surveyData.VolunteerName = event.name;
      console.log(`event.isValid: ${event.isValid}`);
      if (event.isValid) {
        this.isValid = event.isValid;
        this.moveNext();
      }
    },
    isStepValid() {
      console.log(this.isValid);
      return this.isValid;
    },
    moveNext() {
      //if (this.isStepValid()) {
      console.log("Move Next");
      if (this.surveyStep >= 1 && this.surveyStep > this.maxStepCompleted) 
        this.maxStepCompleted += 1; //Since we are passed the first step, start tracking the max step completed

      this.surveyStep += 1;

      if (this.surveyStep >= 1 && this.surveyStep <=8 ){
        //TODO: As we move through the steps, add/update local storage with the survey data
        this.currentStep = `Step${this.surveyStep}`;
      }

      if (this.surveyStep == 8) {
        //We've reached the end of the survey
        console.log("saving...");
        this.IsComplete = true;
        this.axios
          .post("surveys/add", this.surveyData)
          .then(res => (this.surveyData = res.data)) //TODO: Upon success, remove the survey data from local storage
          .catch(err => console.log(err));
          this.resetSurveyData();
      } 

      if(this.surveyStep > 8){        
        this.surveyStep = 0;
        this.currentStep = "";
        this.maxStepCompleted = 0;
      }
      //}
    },
    movePrevious() {
      if (this.surveyStep > 1) {
        this.surveyStep -= 1;
        this.currentStep = `Step${this.surveyStep}`;
      }
      if (this.surveyStep === 0) {
        this.surveyStep = 1;
        this.currentStep = "";
      }
    },
    moveToStep(event) {
      console.log("Survey Move to step: " + event);
      this.surveyStep = event;
    },
    resetSurveyData() {
      console.log("resetting the data");
      //NOTE: when resetting the data, we will keep the VolunteerName
      this.surveyData = {
        Id: 0,
        IsComplete: false,
        LocationId: 0,
        VolunteerId: 0,
        DiagnosedDiabetes: null, //boolean
        Age: null, //number
        Gender: null, //boolean
        DiagnosedGestationalDiabetes: null, //boolean
        RelativeWithDiabetes: null, //boolean
        DiagnosedHighBP: null, //boolean
        PhysicallyActive: null, //boolean
        Weight: null,
        HeightFeet: null,
        HeightInches: null,
        TotalRiskScore: 0,
        BMI: 0,
        Race: "",
        Ethnicity: null, //passed as 1 or 2
        CountryOfBirth: null,
        ZipCode: "",
        HaveHealthCoverage: null, //boolean
        HealthInsurancePlanName: "",
        ContactForHealthCoverage: null, //tinyint
        ContactForDiabetesPrevention: null, //boolean
        FirstAndLastName: "",
        TelephoneNumber: "",
        EmailAddress: "",
        HavePrimaryDoctor: null, //boolean
        FollowUpResults: null, //boolean
        GlucoseReading: null,
        A1CNumber: null,
        LipidsCholHdl: null,
        LipidsLdlC: null,
        LipidsChol: null,
        LipidsHdlC: null,
        LipidsTrig: null
      };
    },
    logOut() {
      this.resetSurveyData();
      this.locationId = 0;
      this.surveyStep = 0;
      this.currentStep = "";
    }
  }
};
</script>
.
<style scoped>
* {
  font-family: "Roboto", sans-serif;
}
.survey-footer{
  padding-bottom: 5px;
  z-index: 2000;
}
.row{
  padding-bottom: 0px;
}
</style>
